import { UsersTemplate } from "../../templates/UsersTemplate/UsersTemplate";

export const UsersPage = () => {
  return <UsersTemplate />;
};
